export const buildLogoStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["box-shadow-horizontal-distance"]
          ? `${element.options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-vertical-distance"]
          ? `${element.options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-blur-radius"]
          ? `${element.options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-spread-radius"]
          ? `${element.options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-color"]
          ? element.options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    const controlStyle = element.options["control-style"] ? element.options["control-style"] : "width";

    // prettier-ignore
    const desktopStyles = 
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"][data-type="logo"] img {
  display: inline !important;
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${controlStyle == "width" && element.options['image-width'] ? `height: initial !important; width: ${element.options['image-width']}px !important;` : ''}
  ${controlStyle == "height" && element.options['image-height'] ? `width: initial !important; height: ${element.options['image-height']}px !important;` : ''}
  ${controlStyle == "width" && ["logo"].includes(element.element_type) && element.options['image-width'] ? `width: ${element.options['image-width']}px !important; height: auto !important;` : ''}
  ${controlStyle == "height" && ["logo"].includes(element.element_type) && element.options['image-height'] ? `height: ${element.options['image-height']}px !important; width: auto !important; max-width: 100% !important; object-fit: contain !important;` : ''}
}
`;

  const controlStyleMobile = element.options["control-style-mobile"]
    ? element.options["control-style-mobile"]
    : element.options["control-style"]
      ? element.options["control-style"]
      : "width";

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"][data-type="logo"] img {
  ${controlStyleMobile == "width" && element.options['image-width-mobile'] ? `height: initial !important; width: ${element.options['image-width-mobile']}px !important;` : ''}
  ${controlStyleMobile == "height" && element.options['image-height-mobile'] ? `width: initial !important; height: ${element.options['image-height-mobile']}px !important;` : ''}
  ${controlStyleMobile == "width" && ["logo"].includes(element.element_type) && element.options['image-width-mobile'] ? `width: ${element.options['image-width-mobile']}px !important; height: auto !important;` : ''}
  ${controlStyleMobile == "height" && ["logo"].includes(element.element_type) && element.options['image-height-mobile'] ? `height: ${element.options['image-height-mobile']}px !important; width: auto !important; max-width: 100% !important; object-fit: contain !important;` : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
